import { Dropdown, Space,  } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { tagsColorBalance } from "../helpers/tagsBage";

/**
 * Balance Component
 * @param {Array<Object>} accPayoutActiveBank - Array ของ object Balance
 * @param {boolean} loadingBankAccounts - สถานะการโหลด
 */
export const UIBalance = ({ accPayoutActiveBank, loadingBankAccounts, t }) => {
    // ป้องกันกรณีข้อมูลไม่ใช่ Array
    const dataArray = Array.isArray(accPayoutActiveBank) ? accPayoutActiveBank : [];

    // ดึงข้อมูลบัญชีแรกมาแสดงเป็นยอดรวมหลัก (หรือปรับตาม Logic ธุรกิจของคุณ)
    const primaryAccount = dataArray.length > 0 ? dataArray[0] : null;
    const mainBalance = primaryAccount ? parseFloat(primaryAccount.balance) : 0;

    // สร้างรายการเมนูสำหรับ Dropdown จาก accPayoutActiveBank
    const items = dataArray.map((item, index) => ({
        key: item.id || index,
        label: (
            <div style={{ padding: '4px 8px' }}>
                <span style={{ marginRight: 8 }}>{t("ACC_WIT_No", { counter: index + 1 })}:</span>
                <span style={{
                    fontWeight: "600",
                    color: tagsColorBalance(mainBalance),
                }}>
                    THB {Intl.NumberFormat('th-TH', { minimumFractionDigits: 2 }).format(item.balance || 0)}
                </span>
            </div>
        ),
    }));

    // ฟังก์ชันช่วย Format ตัวเลข
    const formatNumber = (num) => {
        return Intl.NumberFormat('th-TH', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(num);
    };

    return (
        <Dropdown trigger="hover" arrow menu={{ items }} disabled={dataArray.length <= 1}>
            <Space style={{ cursor: dataArray.length <= 1 ? "default" : "help", }}>
                <div style={{ fontSize: "14px", fontWeight: "600", }}>
                    {loadingBankAccounts ? (
                        <span style={{ color: "#606060" }}>
                            <LoadingOutlined style={{ marginRight: 8 }} spin />
                        </span>
                    ) : (
                        <span style={{
                            fontWeight: "600",
                            color: tagsColorBalance(mainBalance),
                        }}>
                            {mainBalance <= 0 ? "0.00" : formatNumber(mainBalance)}
                            {" "}
                        </span>
                    )}
                </div>
            </Space>
        </Dropdown>
    );
};


/**
 * Balance Component
 * @param {Array<Object>} accPayoutActiveBank - Array ของ object Balance
 * @param {boolean} loadingBankAccounts - สถานะการโหลด
 */
export const UIBalanceWallet = ({ accPayoutActiveBank, loadingBankAccounts, t }) => {
    // ป้องกันกรณีข้อมูลไม่ใช่ Array
    const dataArray = Array.isArray(accPayoutActiveBank) ? accPayoutActiveBank : [];

    // ดึงข้อมูลบัญชีแรกมาแสดงเป็นยอดรวมหลัก (หรือปรับตาม Logic ธุรกิจของคุณ)

    // ฟังก์ชันช่วย Format ตัวเลข
    const formatNumber = (num) => {
        return Intl.NumberFormat('th-TH', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(num);
    };

    return (
        <div className="fs-sm-12" style={{ fontSize: "14px", }}>
            {loadingBankAccounts ? (
                <span style={{ color: "#606060" }}>
                    <LoadingOutlined style={{ marginRight: 8 }} spin />
                    Loading...
                </span>
            ) : (
                dataArray.map((item, index) => (
                    <div className="d-flex justify-space-between w-100" key={item.id || index} style={{ marginBottom: 4 }}>
                        <span style={{ marginRight: 8 }}>{t("ACC_WIT_No", { counter: index + 1 })}</span>
                        <span style={{
                            fontWeight: "600",
                            color: tagsColorBalance(parseFloat(item.balance)),
                        }}>
                            {formatNumber(item.balance || 0)}
                        </span>
                    </div>
                ))
            )}
        </div>
    );
}